/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveQuickOrderViewProps } from './eve-quick-order';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IEveQuickOrderViewProps) => {
    const {
        quickOrderHeader,
        quickOrderTable,
        quickOrderWrapper,
        orderUploadWrapper,
        guideText,
        handleUploadedItems: onUploadItems,
        slots: { orderUpload }
    } = props;

    const _renderGuide = (): JSX.Element | null => {
        const {
            config: { orderUploadHelpLink, orderUploadHelpLinkDisplayText }
        } = props;
        const className = 'eve-quick-order-order-upload__guide';
        return (
            <div className={className}>
                <div className={`${className}-text-wrapper`}>{guideText}</div>
                {orderUploadHelpLink && (
                    <div className={`${className}-link`}>
                        <a aria-label={orderUploadHelpLink.ariaLabel} href={orderUploadHelpLink.linkUrl.destinationUrl || '#'}>
                            {orderUploadHelpLinkDisplayText}
                        </a>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Module {...quickOrderWrapper}>
            {quickOrderHeader}
            {quickOrderTable}
            <Node {...orderUploadWrapper}>
                <div className='eve-quick-order-order-upload__wrapper row'>
                    <div className='col eve-quick-order-order-upload__wrapper--guide'>{_renderGuide()}</div>
                    <div className='col eve-quick-order-order-upload__wrapper--dropzone'>
                        {orderUpload && React.cloneElement(orderUpload[0] as React.ReactElement, { onUploadItems })}
                    </div>
                </div>
            </Node>
        </Module>
    );
};
